import { fork } from 'redux-saga/effects';

import commonSaga from 'modules/common/sagas';
import generalSaga from 'modules/general/sagas';
import masterServicesSaga from 'modules/masterServices/sagas';
import servicesSaga from 'modules/services/sagas';

function* rootSaga() {
  yield fork(commonSaga);
  yield fork(generalSaga);
  yield fork(masterServicesSaga);
  yield fork(servicesSaga);
}

export default rootSaga;
